import { render, staticRenderFns } from "./ShotCourt.vue?vue&type=template&id=0a0c5493&scoped=true&"
import script from "./ShotCourt.vue?vue&type=script&lang=js&"
export * from "./ShotCourt.vue?vue&type=script&lang=js&"
import style0 from "./ShotCourt.vue?vue&type=style&index=0&id=0a0c5493&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a0c5493",
  null
  
)

export default component.exports